import { LiquidationAgreement } from 'features/SubmitProjectProposal/pages';

import Layout from 'layout';
import { LayoutProvider } from 'layout/context/layoutcontext';
import { Can } from 'components/Can';

function DetailLiquidationAgreementPage() {
  return (
    <LayoutProvider>
      <Layout>
        <Can do="read" on="liquidation">
          <LiquidationAgreement readOnly />
        </Can>
      </Layout>
    </LayoutProvider>
  );
}

export default DetailLiquidationAgreementPage;
